//@ts-check
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Core.
import { ErrorValidation, RequiredIcon, Tooltip } from 'core/components';

import 'react-datepicker/dist/react-datepicker.css';

const CustomDatePickDiv = styled.div`
  background-color: white;
  border: solid 0.1em #747474;
  border-radius: 0.25em;
  padding: 0.3em 1em 0 1em;
`;

//TODO: Fix the error about "Type aliases can only be used in TypeScript files.ts(8008)".
/**
 * Custom input for react-datepicker.
 * forwardRef render functions must accept exactly two parameters: props and ref.
 * @param {{ onClick: () => void, value: string }} props
 * @param {React.Ref<HTMLDivElement>} ref
 */
function CustomInputInner({ onClick, value }, ref) {
  return (
    <CustomDatePickDiv ref={ref}>
      <label className="font-weight-normal" onClick={onClick}>
        {value}
      </label>
      &nbsp;
      <FontAwesomeIcon icon={faCalendarAlt} onClick={onClick} />
    </CustomDatePickDiv>
  );
}

const CustomInput = React.forwardRef(CustomInputInner);

/**
 * @param {{
 *    dateId: string
 *    dateName: string
 *    announcementDate: string
 *    dateTitle: string
 *    readOnly: boolean
 *    tooltip: string
 *    onChange: (e) => void
 *    errors?: string []
 * }} props
 */
function AnnouncementDate({
  dateId,
  dateName,
  announcementDate,
  dateTitle,
  readOnly,
  tooltip,
  onChange,
  errors,
}) {
  const [selectedDate, setSelectedDate] = useState(
    announcementDate
      ? new Date(new Date(announcementDate).setHours(0, 0, 0, 0))
      : new Date(),
  );

  useEffect(() => {
    // Populate the start/end date fields with the existing dates.
    announcementDate &&
      setSelectedDate(
        new Date(new Date(announcementDate).setHours(0, 0, 0, 0)),
      );
  }, [announcementDate]);

  return (
    <div className="form-group" id={`announcement-${dateName}-field`}>
      <label>
        <RequiredIcon />
        {dateTitle || 'Date'}
      </label>
      <Tooltip tooltipId="announcement-title-tooltip">{tooltip}</Tooltip>
      <section>
        <DatePicker
          id={dateId}
          name={dateName}
          dateFormat="yyyy-MM-dd"
          selected={selectedDate}
          // Pass placeholders for required props consumed by custom input.
          customInput={
            <CustomInput
              value={
                selectedDate instanceof Date && !Number.isNaN(selectedDate)
                  ? selectedDate.toISOString().slice(0, 10)
                  : ''
              }
              onClick={() => {}}
            />
          }
          onChange={onChange}
        />
      </section>
      <ErrorValidation errors={errors} />
    </div>
  );
}
export { AnnouncementDate };
